import { defineStore } from 'pinia'
import { createState, resetState } from './state'
import { createActions } from './actions'
import { createGetters } from './getters'

export const usePetitionsStore = defineStore('petitions', () => {
  const state = createState()
  const actions = createActions(state)
  const getters = createGetters(state)

  const $reset = () => {
    resetState(state)
  }

  return {
    // State
    ...state,
    // Getters
    ...getters,
    // Actions
    ...actions,
    // Reset
    $reset,
  }
})
